import { object, string, boolean, mixed } from '~utils/validation';
import { parseCurrencyStringToNumber } from '~utils/formatters';

export const validationRepresentative = object({
  name: string().max(255).name().required(),
  email: string().email().required(),
  cellphone: string().cellphone('Número de telefone inválido').required(),
  cpf: string().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: string().cpf().required(),
    otherwise: string().nullable(),
  }),
  birthdayDate: string().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: string().birthdayDate().required(),
    otherwise: string().nullable(),
  }),
  motherName: string().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: string().name().required(),
    otherwise: string().nullable(),
  }),
  zipCode: string().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: string().zipCode().required(),
    otherwise: string().nullable(),
  }),
  state: string().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: string().required(),
    otherwise: string().nullable(),
  }),
  city: string().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: string().required(),
    otherwise: string().nullable(),
  }),
  socialContract: mixed().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: mixed().when('secondaryRepresentative', {
      is: (secondaryRepresentative: boolean) => secondaryRepresentative,
      then: mixed().nullable(),
      otherwise: mixed().pdf().fileSize(4.3).required('Envio obrigatório'),
    }),
    otherwise: mixed().nullable(),
  }),
  neighborhood: string().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: string().required(),
    otherwise: string().nullable(),
  }),
  street: string().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: string().max(40).required(),
    otherwise: string().nullable(),
  }),
  number: string().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: string().required(),
    otherwise: string().nullable(),
  }),
  complement: string().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: string().optional(),
    otherwise: string().nullable(),
  }),
  declaredIncome: string().when('allFields', {
    is: (allFields: boolean) => allFields,
    then: string()
      .max(22)
      .test(
        'positive-number',
        'número deve ser maior ou igual a 1 (um).',
        (value) => parseCurrencyStringToNumber(value) >= 1
      )
      .required(),
    otherwise: string().nullable(),
  }),
  politicallyExposedPerson: boolean().optional(),
  allFields: boolean(),
  secondaryRepresentative: boolean(),
});
